import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Negotiating is certainly going to be a key factor in being able
                                                to win resources in your current job.
                                                But this tool aims to address all of the issues that you will
                                                face when trying to win and then
                                                manage resources.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>RESOURCE MANAGEMENT CYCLE
                                            </div>
                                            <p>Effective management can be as much about acquiring appropriate
                                                or sufficient resources as
                                                deploying them – whether people, equipment or funds. Preparing a
                                                business case and persuading
                                                decision makers to provide what you need takes as much careful
                                                planning as the day-to-day
                                                running of a project or business.</p>
                                            <p>Managing resources is an ongoing, cyclical process which we’ll
                                                separate into stages to help you
                                                ensure daily and long–term smooth running – here’s a simple
                                                model of what we mean:</p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/win_cycle.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}